// extracted by mini-css-extract-plugin
export default {"root":"_3usi_3veKynSGeCGBGK9JG","modal":"_3KvhLNf1A9ToYnptVOX3AV"};